(function () {
  'use strict';
  var nativeFetch = window.fetch.bind(window);
  function root() { return window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/'; }
  function live(c) { return c && c.eligibility_mode === 'live_collections'; }
  function blocked(c, p) {
    return !p || p.blocked || Number(p.id) === 9327658369241 || (c.permanently_excluded_product_ids || []).some(function (id) { return String(id).split('/').pop() === String(p.id); });
  }
  function member(p, id) { return Boolean(id && (p.collections || []).indexOf(id) !== -1); }
  function qualifies(c, p, key) {
    if (!live(c) || blocked(c, p)) return false;
    if (key === 'choose2') return c.enabled && member(p, c.choose_collection_id);
    if (key === 'spend') {
      var excluded = [c.choose_collection_id].concat(c.exclusion_collection_ids || [], (c.campaigns || []).map(function (a) { return a.collection_id; }));
      return c.spend && c.spend.enabled && member(p, c.spend_collection_id) && !excluded.some(function (id) { return member(p, id); });
    }
    var campaign = (c.campaigns || []).find(function (a) { return a.key === key; });
    return Boolean(campaign && campaign.enabled && member(p, campaign.collection_id));
  }
  function giftPool(rule, variantId) {
    var id = String(variantId || '').split('/').pop();
    var override = (rule.variant_gift_rules || []).find(function (r) { return r.purchase_variant_ids.some(function (v) { return String(v).split('/').pop() === id; }); });
    return (override ? [override.gift_variant_id] : rule.gift_variant_ids || [rule.gift_variant_id]).map(function (v) { return String(v).split('/').pop(); });
  }
  var giftLookups = {};
  // Resolve missing Liquid products by immutable variant ID, never by an old URL.
  function giftVariants(ids) {
    ids = Array.from(new Set(ids.map(function (id) { return String(id).split('/').pop(); }).filter(function (id) { return /^\d+$/.test(id); })));
    var missing = ids.filter(function (id) { return !giftLookups[id]; });
    if (missing.length) {
      var controller = new AbortController();
      var timeout = window.setTimeout(function () { controller.abort(); }, 8000);
      var request = nativeFetch('/api/2026-07/graphql.json', {
        method: 'POST', credentials: 'same-origin', signal: controller.signal,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ query: 'query PromotionGiftVariants($ids:[ID!]!,$country:CountryCode!) @inContext(country:$country){nodes(ids:$ids){...on ProductVariant{id title availableForSale price{amount currencyCode} image{url} product{id title handle featuredImage{url}}}}} ', variables: { ids: missing.map(function (id) { return 'gid://shopify/ProductVariant/' + id; }), country: window.Shopify && window.Shopify.country || 'US' } })
      }).then(function (response) { if (!response.ok) throw new Error('Gift lookup unavailable'); return response.json(); })
        .then(function (data) { if (data.errors || !data.data || !Array.isArray(data.data.nodes)) throw new Error('Gift lookup unavailable'); return data.data.nodes; })
        .finally(function () { window.clearTimeout(timeout); });
      missing.forEach(function (id) {
        giftLookups[id] = request.then(function (nodes) {
          return nodes.find(function (v) { return v && String(v.id).split('/').pop() === id && String(v.product.id).split('/').pop() !== '9327658369241'; }) || null;
        }).catch(function (error) { delete giftLookups[id]; throw error; });
      });
    }
    return Promise.all(ids.map(function (id) { return giftLookups[id]; }));
  }
  function hydrateGifts(container) {
    var options = Array.from(container.querySelectorAll('[data-ns-gift-unresolved]'));
    if (!options.length) return Promise.resolve();
    return giftVariants(options.map(function (option) { return option.dataset.variantId; })).then(function (variants) {
      options.forEach(function (option) {
        var variant = variants.find(function (v) { return v && String(v.id).split('/').pop() === option.dataset.variantId; });
        var available = Boolean(variant && variant.availableForSale);
        option.disabled = !available;
        option.dataset.nsGiftAvailable = available ? 'true' : 'false';
        var status = option.querySelector('[data-ns-gift-availability]');
        if (status) status.textContent = available ? 'FREE' : 'Unavailable';
        if (variant) {
          var title = option.querySelector('strong');
          if (title) title.textContent = variant.product.title + (variant.title === 'Default Title' ? '' : ' · ' + variant.title);
          option.dataset.giftName = variant.product.title;
          var media = option.querySelector('.ns-b1g2-gift__media');
          var image = variant.image || variant.product.featuredImage;
          if (media && image) { var img = document.createElement('img'); img.src = image.url; img.alt = variant.product.title; img.loading = 'lazy'; media.replaceChildren(img); }
        }
        option.removeAttribute('data-ns-gift-unresolved');
      });
    }).catch(function () {
      options.forEach(function (option) { option.dataset.nsGiftAvailable = 'false'; var status = option.querySelector('[data-ns-gift-availability]'); if (status) status.textContent = 'Gift availability could not be checked. Please refresh to try again.'; });
    });
  }
  function resolveRewards(data) {
    if (!data.rewards || !data.config.spend || !data.config.spend.enabled) return Promise.resolve(data);
    var missing = (data.config.spend.tiers || []).map(function (tier, i) { return { tier: tier, key: 'tier-' + (i + 1), alias: ['one','two','four'][i] }; }).filter(function (entry) {
      var gift = data.rewards[entry.key];
      return !gift || String(gift.variantId) !== String(entry.tier.variant_id).split('/').pop();
    });
    if (!missing.length) return Promise.resolve(data);
    return giftVariants(missing.map(function (entry) { return entry.tier.variant_id; })).then(function (variants) {
      missing.forEach(function (entry) {
        var variant = variants.find(function (v) { return v && v.id === entry.tier.variant_id; });
        if (!variant) return;
        var gift = { variantId: Number(variant.id.split('/').pop()), price: Math.round(Number(variant.price.amount) * 100), available: variant.availableForSale };
        data.rewards[entry.key] = gift;
        if (entry.alias) data.rewards[entry.alias] = gift;
      });
      return data;
    }).catch(function () { return data; });
  }
  function json(url) {
    return nativeFetch(url + (url.indexOf('?') === -1 ? '?' : '&') + '_ns=' + Date.now(), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'text/html' } }).then(function (r) {
      if (!r.ok) throw new Error('Your gift eligibility could not be checked. Please refresh your cart.');
      return r.json().then(function (data) { return live(data.config) ? resolveRewards(data) : data; });
    });
  }
  function product() {
    var entry = window.NSGiftCampaignConfig && window.NSGiftCampaignConfig.productEntry;
    if (!entry || !entry.handle) return Promise.resolve(null);
    return json(root() + 'products/' + encodeURIComponent(entry.handle) + '?view=ns-eligibility');
  }
  function apply(data, page) {
    var config = window.NSGiftCampaignConfig;
    if (!config || !live(data.config)) return;
    config.liveEligibility = true;
    if (!data.config.spend || !Array.isArray(data.config.spend.tiers) || !data.config.spend.tiers.length || data.config.spend.tiers.length > 10) { config.spend.enabled = false; config.spend.eligibleProductIds = []; config.spend.excludedProductIds = []; return; }
    config.spend.enabled = Boolean(data.config.spend && data.config.spend.enabled);
    config.spend.tiers = data.config.spend.tiers;
    var products = (data.items || []).map(function (i) { return i.product; });
    if (page && page.product) products.push(page.product);
    config.spend.eligibleProductIds = products.filter(function (p) { return qualifies(data.config, p, 'spend'); }).map(function (p) { return Number(p.id); });
    config.spend.excludedProductIds = products.filter(function (p) { return !qualifies(data.config, p, 'spend'); }).map(function (p) { return Number(p.id); });
    if (data.rewards) config.gifts = data.rewards;
    var popup = document.querySelector('[data-ns-native-promo]');
    if (popup && page && page.product) {
      var key = popup.dataset.promoKey;
      var managed = key === 'choose2' || (data.config.campaigns || []).some(function (c) { return c.key === key; });
      if (managed) {
        popup.dataset.nsEligibility = qualifies(data.config, page.product, key) ? 'true' : 'false';
        document.querySelectorAll('[data-ns-native-promo-open]').forEach(function (button) { button.hidden = popup.dataset.nsEligibility === 'false'; });
      }
    }
    document.dispatchEvent(new CustomEvent('ns:eligibility'));
  }
  function cart(cart) {
    if (window.NSLiveEligibilityMode !== 'live_collections') return Promise.resolve(cart);
    return Promise.all([json(root() + 'cart?view=ns-eligibility'), product()]).then(function (values) {
      var data = values[0], page = values[1];
      if (!live(data.config) || !Array.isArray(data.items) || data.items.length !== cart.items.length || cart.items.some(function (i) {
        return !data.items.some(function (a) { return a.key === i.key && a.quantity === i.quantity && Number(a.product.id) === Number(i.product_id); });
      })) throw new Error('Your cart changed while checking gift eligibility. Please refresh your cart.');
      cart.nsEligibility = data;
      apply(data, page);
      return cart;
    });
  }
  function bundle(cart, offer, gifts) {
    if (window.NSLiveEligibilityMode !== 'live_collections') return true;
    var data = cart.nsEligibility;
    if (!data || !offer) return false;
    var key = offer.properties && offer.properties['_NS promotion key'];
    var rule = key === 'choose2' ? { enabled: data.config.enabled, gift_variant_ids: data.config.gift_variant_ids, gift_quantity: 2 } : (data.config.campaigns || []).find(function (a) { return a.key === key; });
    if (!rule) return true; // Native offers outside this App retain their own guard.
    var p = data.items.find(function (a) { return a.key === offer.key; });
    if (!p || !qualifies(data.config, p.product, key) || (key !== 'choose2' && gifts.length !== Number(rule.gift_quantity || 1))) return false;
    var pool = giftPool(rule, offer.variant_id || offer.id);
    return gifts.every(function (g) {
      var a = data.items.find(function (i) { return i.key === g.key; });
      return a && !blocked(data.config, a.product) && pool.indexOf(String(g.variant_id || g.id)) !== -1;
    });
  }
  function offer(key, selected, quantity, purchaseVariantId) {
    if (window.NSLiveEligibilityMode !== 'live_collections') return Promise.resolve();
    return product().then(function (data) {
      if (!data || !qualifies(data.config, data.product, key)) throw new Error('This saber no longer qualifies for this gift offer. Refresh the page or add the saber without gifts.');
      var rule = key === 'choose2' ? { gift_quantity: 2, gift_variant_ids: data.config.gift_variant_ids } : (data.config.campaigns || []).find(function (c) { return c.key === key; });
      if ((rule.variant_gift_rules || []).length && !purchaseVariantId) throw new Error('Please select your saber version again.');
      var pool = giftPool(rule, purchaseVariantId);
      if (Number(rule.gift_quantity || 1) !== quantity || selected.some(function (id) { return pool.indexOf(String(id)) === -1; })) throw new Error('This gift offer has changed. Please refresh the page to choose the current gifts.');
    });
  }
  window.NSLiveEligibility = { cart: cart, bundle: bundle, offer: offer, qualifies: qualifies, giftPool: giftPool, hydrateGifts: hydrateGifts };
  var initial = window.NSGiftCampaignConfig;
  if (initial && initial.liveProduct && initial.liveRules) apply({ config: initial.liveRules, items: [], rewards: null }, { product: initial.liveProduct });
})();
